import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  coverImage: string;
  categoryName: string;
  categorySlug: string;
  author: string;
  publishedAt: string;
  readTime: string;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  coverImage,
  categoryName,
  categorySlug,
  author,
  publishedAt,
  readTime,
}: ArticleCardProps) {
  return (
    <article className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 group cursor-pointer">
      <Link to={`/article/${slug}`} className="no-underline">
        <div className="relative overflow-hidden aspect-[16/9]">
          <img
            src={coverImage}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute top-3 left-3">
            <Link
              to={`/category/${categorySlug}`}
              className="px-3 py-1 rounded-full text-xs font-medium bg-background-50/90 text-primary-600 backdrop-blur-sm whitespace-nowrap cursor-pointer no-underline hover:bg-primary-100 transition-colors"
              onClick={(e) => e.stopPropagation()}
            >
              {categoryName}
            </Link>
          </div>
        </div>
        <div className="p-5">
          <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
            {title}
          </h3>
          <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">
            {excerpt}
          </p>
          <div className="flex items-center justify-between text-xs text-foreground-400">
            <div className="flex items-center gap-3">
              <span className="flex items-center gap-1">
                <i className="ri-user-line"></i>
                {author}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-time-line"></i>
                {readTime}
              </span>
            </div>
            <span>{publishedAt}</span>
          </div>
        </div>
      </Link>
    </article>
  );
}